// Alert Type Configuration - Single Source of Truth
export const ALERT_TYPES = {
  success: {
    label: 'Success',
    defaultColor: '#10b981',
    defaultIcon: '✓',
    defaultTitle: 'Success',
    defaultMessage: 'Operation completed successfully',
    defaultPrimaryButton: 'OK',
  },
  error: {
    label: 'Error',
    defaultColor: '#ef4444',
    defaultIcon: '✕',
    defaultTitle: 'Error',
    defaultMessage: 'An error occurred. Please try again.',
    defaultPrimaryButton: 'OK',
  },
  warning: {
    label: 'Warning',
    defaultColor: '#f59e0b',
    defaultIcon: '⚠',
    defaultTitle: 'Warning',
    defaultMessage: 'Please review this action before proceeding.',
    defaultPrimaryButton: 'OK',
  },
  info: {
    label: 'Info',
    defaultColor: '#3b82f6',
    defaultIcon: 'ℹ',
    defaultTitle: 'Information',
    defaultMessage: 'Here is some information for you.',
    defaultPrimaryButton: 'OK',
  },
  custom: {
    label: 'Custom',
    defaultColor: '#6b7280',
    defaultIcon: '•',
    defaultTitle: 'Alert',
    defaultMessage: 'This is a custom alert message.',
    defaultPrimaryButton: 'OK',
  },
};

// Animation Types Configuration
export const ANIMATION_TYPES = [
  { value: 'fade', label: 'Fade', defaultDuration: 0.3 },
  { value: 'slide', label: 'Slide', defaultDuration: 0.3 },
  { value: 'scale', label: 'Scale', defaultDuration: 0.3 },
  { value: 'bounce', label: 'Bounce', defaultDuration: 0.5 },
  { value: 'none', label: 'None', defaultDuration: 0 },
];

// Button Styles Configuration
export const BUTTON_STYLES = [
  { value: 'borderedProminent', label: 'Prominent' },
  { value: 'bordered', label: 'Bordered' },
  { value: 'plain', label: 'Plain' },
  { value: 'borderless', label: 'Borderless' },
];

// Default Alert Configuration
export const DEFAULT_ALERT_CONFIG = {
  type: 'success',
  title: 'Success',
  message: 'Operation completed successfully',
  buttonCount: 1,
  primaryButtonText: 'OK',
  secondaryButtonText: 'Cancel',
  tertiaryButtonText: 'Delete',
  cornerRadius: 12,
  blurBackground: true,
  blurIntensity: 10,
  animationType: 'fade',
  animationDuration: 0.3,
  backgroundColor: '#ffffff',
  titleColor: '#000000',
  messageColor: '#666666',
  // New dynamic features
  customTypeColor: null, // Override type color when type is 'custom'
  customIcon: null, // Custom icon text/emoji
  showIcon: true,
  dismissible: true, // Can be dismissed by tapping outside
  autoDismiss: false,
  autoDismissDelay: 3, // seconds
  primaryButtonStyle: 'borderedProminent',
  secondaryButtonStyle: 'bordered',
  tertiaryButtonStyle: 'bordered',
  primaryButtonColor: null, // null = use type color
  shadowEnabled: true,
  shadowRadius: 20,
  shadowOpacity: 0.1,
  padding: 24,
};

/**
 * Get alert type configuration
 * @param {string} type - Alert type (success, error, warning, info, custom)
 * @returns {Object} Alert type configuration
 */
export const getAlertTypeConfig = (type) => {
  return ALERT_TYPES[type] || ALERT_TYPES.custom;
};

/**
 * Get effective color (custom or type default)
 * @param {Object} config - Alert configuration object
 * @returns {string} Hex color string
 */
export const getEffectiveColor = (config) => {
  if (config.type === 'custom' && config.customTypeColor) {
    return config.customTypeColor;
  }
  return getAlertTypeConfig(config.type || 'success').defaultColor;
};

/**
 * Get effective icon (custom or type default)
 * @param {Object} config - Alert configuration object
 * @returns {string} Icon character/emoji
 */
export const getEffectiveIcon = (config) => {
  if (config.customIcon) {
    return config.customIcon;
  }
  return getAlertTypeConfig(config.type || 'success').defaultIcon;
};

